import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31689bfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selectarea" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select-t" }, "人员出入", -1))
const _hoisted_3 = { class: "personlist" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "person-action" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "time-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tip" }, "进入时间", -1))
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "time-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tip" }, "离开时间", -1))
const _hoisted_12 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "selecttime",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fOpenCalendar && _ctx.fOpenCalendar(...args)))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.date), 1),
        _createVNode(_component_van_icon, { name: "calendar-o" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": "没有更多了",
            "loading-text": "正在加载,请稍后..",
            onLoad: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "person",
                  key: index
                }, [
                  _createElementVNode("img", {
                    class: "person-avtor",
                    src: item.photoUrl
                  }, null, 8, _hoisted_4),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.name ? item.name : "访客"), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("span", _hoisted_9, _toDisplayString(item.inDate), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("span", _hoisted_12, _toDisplayString(item.outDate), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ]),
    _createVNode(_component_van_calendar, {
      "min-date": new Date('2019-01-01'),
      "close-on-click-overlay": "",
      show: _ctx.calendarShow,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.calendarShow) = $event)),
      onConfirm: _ctx.fConfirmDate
    }, null, 8, ["min-date", "show", "onConfirm"])
  ], 64))
}